package com.xtream.ui.tv.presentation.movies

 import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.calculateStartPadding
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.rounded.GridView
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.snapshotFlow
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.platform.LocalWindowInfo
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.paging.compose.collectAsLazyPagingItems
import com.xtream.composeapp.LocalAppViewModelStoreOwner
import com.xtream.composeapp.data.Screen
import com.xtream.composeapp.presentation.ui.content.ContentScreen
import com.xtream.composeapp.presentation.ui.navigation.RootNavViewModel
import com.xtream.sharedResources.resources.Res
import com.xtream.sharedResources.resources.view_all
import com.xtream.composeapp.viewmodel.VodStreamsViewModel
import com.xtream.data_kmp.AllConst
import com.xtream.data_kmp.WatchedIntermediateVodStream
import com.xtream.data_kmp.dto.VodStream
import com.xtream.ui.ui.widget.ImageCard
import com.xtream.ui.ui.widget.NetworkImageCard
import com.xtream.ui.ui.widget.Visibility
import com.xtream.ui.ui.widget.rememberAnimatedItemAlpha
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel

@OptIn(ExperimentalStdlibApi::class)
@Composable
fun MoviesTvScreen(
    navKey: Screen.Movies,
    rowsContentPadding: PaddingValues,
    contentPadding: PaddingValues,
    onFirstItemVisibleChanged: ((index: Int) -> Unit)? = null

    ){
    val viewModelStoreOwner =LocalAppViewModelStoreOwner.current
    val rootNavViewModel: RootNavViewModel = koinViewModel(
        viewModelStoreOwner= viewModelStoreOwner
    )
    val vodStreamsViewModel: VodStreamsViewModel = koinViewModel( key=navKey.toString())/* hiltViewModel<VodStreamsViewModel, VodStreamsViewModel.Factory>(
        creationCallback = { factory ->
            factory.create(navKey)
        }
    )*/

    val pagerFlow = vodStreamsViewModel.categoriesPagerWithTvStreams

    val homeScreenPagedItems = pagerFlow.collectAsLazyPagingItems()


         //   Log.d("MoviesTvScreen", "pagerFlow: ${pagerFlow.hashCode()}")
          //  Log.d("MoviesTvScreen", "MoviesTvScreen: ${homeScreenPagedItems.hashCode()}")

    val listScrollState = rememberSaveable(saver = LazyListState.Saver) {
        LazyListState()
    }
    val layoutDirection = LocalLayoutDirection.current

    val density = LocalDensity.current
    val screenWidthDp = with(density) {
        LocalWindowInfo.current.containerSize.width.toDp()
    }
    val startPadding = rowsContentPadding.calculateStartPadding( layoutDirection)

    val parentFraction = remember(screenWidthDp) {
        startPadding.value / screenWidthDp.value
    }

    ContentScreen(
listState = listScrollState,
        rowItemFraction = parentFraction,
        contentPadding = contentPadding,

        rowsContentPadding =   PaddingValues( start = startPadding, end=screenWidthDp),


        carousel = {

        },
        lazyPagingItems = homeScreenPagedItems,
        /*onCategoryClicked = {
            rootNavViewModel.navigate(Screen.MoviesGrid(it?.categoryId, it?.categoryName))
        },*/
        buildExtraContent = { item, title, rowFocusRequester, columnFocusRequester ->

            val categoryId =
                when(item){
                is WatchedIntermediateVodStream -> AllConst.WATCHED_CATEGORIES_ID.toInt()
                is VodStream ->item.categoryId
                else->null

            }
                ImageCard(
                    rememberVectorPainter(Icons.Rounded.GridView),
                    title = stringResource(Res.string.view_all),
                    textAlign = TextAlign.Center,

                    description = "",

                    onClick = {
                        columnFocusRequester?.saveFocusedChild()
                        rowFocusRequester?.saveFocusedChild()
                        rootNavViewModel.navigate(Screen.MoviesGrid(categoryId, title))
                    },
                    aspectRatio = 2f/3,
//                    dependOnWidth = item is VodStream,

                )

        }

    ){it ,columnFocusRequester, rowFocusRequester, focusRequester,index, rowListState->
        val itemAlpha by rowListState.rememberAnimatedItemAlpha( index = index   )

        (it as? WatchedIntermediateVodStream)?.let {stream->
            NetworkImageCard(
                modifier = Modifier.graphicsLayer{
                    alpha=itemAlpha
                }.then(
                    if (focusRequester != null)
                        Modifier.focusRequester(focusRequester)
                    else
                        Modifier
                ),
                src= stream.watchedBaseStream.backdrop,
                title = stream.baseStream.name?:"",
                description = stream.baseStream.formattedRating()?:"",
                infoSectionVisibility = Visibility.VISIBLE_ON_FOCUS,
                onClick = {
                    columnFocusRequester?.saveFocusedChild()
                    rowFocusRequester?.saveFocusedChild()

                    rootNavViewModel.navigate(Screen.MovieDetail(stream.baseStream.streamId))
                },

                aspectRatio = 16f/9f,
                width =  196.dp,
                progress = stream.watchedBaseStream.progress.let {progress->
                    val totalProgress=stream.watchedBaseStream.totalProgress
                    if (progress == null || progress==0L||  totalProgress==null||totalProgress == 0L)
                        0f
                    else
                        progress/totalProgress.toFloat()
                }.coerceIn(0f,1f)
            )
        }
        (it as? VodStream?)?.let {stream->
            NetworkImageCard(
                modifier = Modifier.graphicsLayer{
                    alpha = itemAlpha
                }.then(
                    if (focusRequester != null)
                        Modifier.focusRequester(focusRequester)
                    else
                        Modifier
                ),
                infoSectionVisibility = Visibility.VISIBLE_ON_FOCUS,

                src=stream.streamIcon,
                title = stream.name?:"",
                description = stream.formattedRating()?:"",

                onClick = {
                    columnFocusRequester?.saveFocusedChild()
                    rowFocusRequester?.saveFocusedChild()

                    //vodStreamsViewModel.updateFavoriteStatus( stream)
                    rootNavViewModel.navigate(Screen.MovieDetail(stream.streamId))
                }
            )
        }

    }



    LaunchedEffect(listScrollState) {
        // 1. distinctUntilChanged: ensures we only get updates when the boolean actually flips
        snapshotFlow { listScrollState.isScrollInProgress }
            .collect { isScrolling ->
                if (!isScrolling) {
                    // The list is now Idle
                    val currentIndex = listScrollState.firstVisibleItemIndex
                    onFirstItemVisibleChanged?.invoke(currentIndex)
                }
            }
    }
}
